import domReady from '@wordpress/dom-ready';
import {on} from 'delegated-events';

const accordions = {
  classes: {
    accordion: 'accordion',
    trigger: 'accordion-trigger',
    panel: 'accordion__text',
    wrapper: 'accordion__wrapper',
    init: 'init-accordions',
  },
};

domReady(function() {
  initAccordions();
});

/**
 * initialize all accordion triggers on the page
 */
function initAccordions() {
  document.documentElement.classList.add(accordions.classes.init);

  // make every accordion panel have the hidden attribute
  const accordionPanels = document.querySelectorAll(
    `.${accordions.classes.panel}`
  );
  accordionPanels.forEach((panel) => {
    panel.setAttribute('hidden', '');
  });

  on('click', `.${accordions.classes.trigger}`, toggleAccordionPanel);
  on('keyup', `.${accordions.classes.trigger}`, handleAccordionKeypress);
}

/**
 * Function to control the accordion
 *
 * @param {object} event - event
 */
function toggleAccordionPanel(event) {
  const trigger = event.currentTarget;

  const panel = document.getElementById(trigger.getAttribute('aria-controls'));

  panel.hidden
    ? openAccordionPanel(trigger, panel)
    : closeAccordionPanel(trigger, panel);
}

/**
 * Function to open the accordion
 *
 * @param {HTMLElement} trigger - the trigger connected with this panel
 * @param {HTMLElement} panel - the accordion panel
 */
function openAccordionPanel(trigger, panel) {
  trigger.setAttribute('aria-expanded', true);
  panel.hidden = false;
  trigger.closest(`.${accordions.classes.wrapper}`).classList.add('is-active');
}

/**
 * Function to close the accordion
 *
 * @param {HTMLElement} trigger - the trigger connected with this panel
 * @param {HTMLElement} panel - the accordion panel
 */
function closeAccordionPanel(trigger, panel) {
  trigger.setAttribute('aria-expanded', false);
  panel.hidden = true;
  trigger
    .closest(`.${accordions.classes.wrapper}`)
    .classList.remove('is-active');
}

/**
 * Function to handle the keyboard
 * commands
 * @param {Object} event - Event object
 */
function handleAccordionKeypress(event) {
  console.log('keyup!!');
  console.log(event.key);

  switch (event.key) {
  // Home or fn + left key arrow on mac
  case 'Home':
    event.currentTarget
      .closest(`.${accordions.classes.accordion}`)
      .querySelector(`.${accordions.classes.trigger}`)
      .focus();
    break;
    // End or fn + right key arrow on mac
  case 'End':
    const accordionTriggers = event.currentTarget
      .closest(`.${accordions.classes.accordion}`)
      .querySelectorAll(`.${accordions.classes.trigger}`);

    accordionTriggers[accordionTriggers.length - 1].focus();
    break;
  }
}
